import LoadingScreen from 'components/LoadingScreen';
import { useAtom } from 'jotai';
import callApi from 'lib/callApi';
import moment from 'moment';
import React, { Fragment, useEffect, useState } from 'react';
import { Table, Row, Col } from 'reactstrap';
import { companyIdAtom } from 'views/state';

const headerConfig = [
  { title: '#' },
  { title: 'Open Status' },
  { title: 'Open Date' },
  { title: 'Close Status' },
  { title: 'Close Date' },
  { title: 'Age (Days)' },
];

const TableHeader = headerConfig.map(({ title }) => {
  return (
    <th
      style={title === 'Age (Days)' ? { textAlign: 'right' } : {}}
      key={title}
    >
      {title}
    </th>
  );
});

interface Props {
  posture_info_id: number;
}

async function getStatusData(posture_info_id: number, companyId: number) {
  try {
    if (posture_info_id) {
      const params = {
        posture_info_id: posture_info_id,
        company_id: companyId,
      };

      const responseData = await callApi(
        'pcm/posture/status-history/',
        'GET',
        params,
      );
      return responseData?.data;
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error);
  }
  return [];
}

const StatusDetails = ({ posture_info_id }: Props) => {
  const [loading, setLoading] = useState(false);
  const [statusData, setStatusData] = useState<any[]>([]);
  const [companyId] = useAtom(companyIdAtom);

  useEffect(() => {
    if (posture_info_id) {
      setLoading(true);
      void getStatusData(posture_info_id, companyId).then((data) => {
        setStatusData(data);
        setLoading(false);
      });
    }
  }, [posture_info_id, companyId]);

  return (
    <Fragment>
      <Row>
        <Col>
          <Table className="tablesorter table-striped" responsive>
            <thead className="text-primary">
              <tr>{TableHeader}</tr>
            </thead>
            <tbody>
              {loading && (
                <tr>
                  <td colSpan={6}>
                    <LoadingScreen />
                  </td>
                </tr>
              )}
              {statusData?.map((dataItem, index) => {
                return (
                  <tr key={index} className={'dynamic-select-tr'}>
                    <td className="col-md-1">{index + 1}</td>
                    <td>
                      {dataItem['open_status'] ? dataItem['open_status'] : '-'}
                    </td>
                    <td>
                      {dataItem['open_date'] && dataItem['open_date'].length > 0
                        ? moment(dataItem['open_date']).format('lll')
                        : '-'}
                    </td>
                    <td>
                      {dataItem['close_status']
                        ? dataItem['close_status']
                        : '-'}
                    </td>
                    <td>
                      {dataItem['close_date'] &&
                      dataItem['close_date'].length > 0
                        ? moment(dataItem['close_date']).format('lll')
                        : '-'}
                    </td>
                    <td className="col-md-1" style={{ textAlign: 'right' }}>
                      {dataItem['age_days']}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </Col>
      </Row>
    </Fragment>
  );
};

export default StatusDetails;
